import { initProductBuyTile } from '../../../snippets/product-buy-tile-bundle/product-buy-tile-bundle';

export const initBundlesCloseoutSectionTiles = () => {
  const bundleProductEls = document.querySelectorAll(
    '[data-list-collections-bundles-closeout-product]'
  );

  bundleProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-bundles-closeout-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
